import { Component, EventEmitter, Output } from '@angular/core';

import { SearchParametersService } from '../../../../services/SearchParameters/search-parameters.service';
import {
  IChipEntry,
  IDropDownListEntry,
} from '../../mdm-input/mdm-input-settings';

@Component({
  selector: 'app-component-unspsc-search-parameters',
  templateUrl: './unspsc-search-parameters.component.html',
  styleUrls: ['./unspsc-search-parameters.component.scss'],
  standalone: false,
})
export class UnspscSearchParametersComponent {
  @Output() searchClicked: EventEmitter<IChipEntry[]> = new EventEmitter<
    IChipEntry[]
  >();
  @Output() clearParametersClicked: EventEmitter<any> = new EventEmitter<any>();

  unspscCodes: IDropDownListEntry[] = [];
  selectedUnspscCodes: IChipEntry[] = [];
  unspscCodesLoaded: boolean = false;

  constructor(private searchParameterService: SearchParametersService) {
    const ps = this;

    this.searchParameterService.MismatchedUnspscCodes.then(codes => {
      this.unspscCodes = [];
      codes
        .sort((a, b) => {
          return b.eventCount - a.eventCount;
        })
        .forEach(c => {
          this.unspscCodes.push(
            ps.getDropDownListEntry(
              c.code,
              c.code + ' - ' + c.description + ' (' + c.eventCount + ')',
            ),
          );
        });

      this.unspscCodesLoaded = true;
    });
  }

  disableSearch(): boolean {
    return this.selectedUnspscCodes.length == 0;
  }

  searchClick(): void {
    this.searchClicked.emit(this.selectedUnspscCodes);
  }

  clearParameters(): void {
    this.selectedUnspscCodes = [];
    this.clearDropDownListEntry(this.unspscCodes);
    this.clearParametersClicked.emit();
  }

  getDropDownListEntry(key: string, value: string): IDropDownListEntry {
    return {
      key: key,
      value: value,
      isDisabled: false,
      isSelected: false,
    };
  }

  private clearDropDownListEntry(entry: IDropDownListEntry[]): void {
    entry.forEach(e => {
      e.isSelected = false;
    });
  }
}
